import { DateTime } from 'luxon';
import { ParsedUrlQuery } from 'querystring';
import { DeepWritable } from 'ts-essentials';
import {
  GetHandlesForClientsQuery,
  IgAssetWhereInput,
  StatusType,
} from '@src/generated/hooks';
import { decodeQueryParams } from '@src/util/navigation';

/**
 * @name buildAssetWhereClause
 * @description Builds a where clause for the given query params.
 */
export function buildAssetWhereClause(
  query: ParsedUrlQuery,
  handleIds: string[],
) {
  const { clients, endDate, handles, startDate, statuses, tags } =
    decodeQueryParams(query);
  const where: DeepWritable<IgAssetWhereInput> = {
    AND: [],
  };

  if (clients && clients.length && handleIds && handleIds.length > 0) {
    where.AND?.push({
      idHandleId: {
        in: handleIds,
      },
    });
  }

  if (tags && tags.length) {
    where.AND?.push({
      tag: {
        some: {
          name: {
            in: tags,
          },
        },
      },
    });
  }

  if (handles && handles.length > 0) {
    where.AND?.push({
      igHandle: {
        is: {
          handle: {
            in: handles,
          },
        },
      },
    });
  }

  if (statuses && statuses.length > 0) {
    where.AND?.push({
      status: {
        in: statuses as StatusType[],
      },
    });
  }

  if (startDate) {
    where.AND?.push({
      createdAt: {
        gte: DateTime.fromJSDate(startDate).toISO(),
      },
    });
  }

  if (endDate) {
    where.AND?.push({
      createdAt: {
        lte: DateTime.fromJSDate(endDate).toISO(),
      },
    });
  }

  return where;
}

/**
 * @name getAllHandleIds
 * @description Returns all the handles in an array given the query data from
 * all the campaigns.
 */
export function getAllHandleIds(handleData?: GetHandlesForClientsQuery) {
  if (!handleData) {
    return [];
  }

  const { clients } = handleData;

  // Get all the handles from the campaigns.
  const ret: string[] = [];
  clients.forEach((client) => {
    client?.igHandles.forEach((handle) => {
      ret.push(handle.id);
    });
  });

  return ret;
}
